/**
 * @fileoverview DonateSection Component - Support/Donation CTA
 *
 * Reusable component for displaying the donation call-to-action with
 * Stripe payment link. Used in DownloadStep and ProcessingOverlay.
 *
 * @requires React
 */
import React from 'react';

// Official Stripe wordmark logo (stored locally in /public/stripe-logo.svg)
const StripeBadge = () => (
  <img
    src="/stripe-logo.svg"
    alt="Stripe"
    className="h-5 inline-block ml-1"
  />
);

// Shield icon SVG
const ShieldIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
  </svg>
);

/**
 * DonateSection Component
 *
 * @param {Object} props
 * @param {string} props.className - Additional CSS classes
 * @returns {JSX.Element}
 */
function DonateSection({ className = '' }) {
  const STRIPE_DONATE_URL = 'https://buy.stripe.com/bJebJ2eWl0wh6J8dr34wM00';

  return (
    <div className={`bg-gradient-to-br from-blue-500/10 to-cyan-500/10 border border-blue-500/20 rounded-xl p-5 ${className}`}>
      <div className="flex items-center justify-center gap-2 mb-3">
        <ShieldIcon className="w-6 h-6 text-blue-400" />
        <h3 className="text-lg font-semibold text-blue-300">Support LetsBlur</h3>
      </div>
      <p className="text-sm text-gray-300 leading-relaxed mb-4">
        Privacy is a right, not a privilege. Your support helps us keep LetsBlur free for journalists,
        activists, families, and anyone who needs it. Together, we can protect privacy for good.
      </p>
      <a
        href={STRIPE_DONATE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-blue-500 to-cyan-500 hover:from-blue-600 hover:to-cyan-600 rounded-xl font-semibold transition-all transform hover:scale-105 shadow-lg shadow-blue-500/25"
      >
        <ShieldIcon className="w-5 h-5" />
        Support LetsBlur
      </a>
      <div className="mt-3 flex items-center justify-center gap-1 text-gray-500">
        <span className="text-xs">Powered by</span>
        <StripeBadge />
      </div>
    </div>
  );
}

export default DonateSection;
